module.exports = __webpack_public_path__ + "img/story-oculus.3f0cc5ab.svg";